// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"styles_inputBox__2sU1X","disabled":"styles_disabled__317Fi"};